import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { ATTACHMENTS_DETAIL, ATTACHMENTS_LIST } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: {
        create: request_state(),
        remove: request_state(),
        rename: request_state(),
    },
    mutations: {
        ...request_mutations('create_attachment', 'create'),
        ...request_mutations('remove_attachment', 'remove'),
        ...request_mutations('rename_attachment', 'rename'),
    },
    actions: {
        create({ commit }, { space_id, note_id, data }) {
            const url = ATTACHMENTS_LIST
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id);

            commit('create_attachment_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_attachment_success', response.data);
                    commit('notes/add_attachment', response.data, { root: true });
                    resolve(response.data);
                }).catch((error) => {
                    commit('create_attachment_error', error.response ? error.response.data : {});
                });
            });
        },
        rename({ commit }, {
            space_id, note_id, attachment_id, name,
        }) {
            const url = ATTACHMENTS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{attachment_id}', attachment_id);

            commit('rename_attachment_loading');
            return new Promise((resolve) => {
                axios.put(url, { name }, auth()).then((response) => {
                    commit('rename_attachment_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('rename_attachment_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, { space_id, note_id, attachment_id }) {
            const url = ATTACHMENTS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{attachment_id}', attachment_id);

            commit('remove_attachment_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_attachment_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('remove_attachment_error', error.response ? error.response.data : {});
                });
            });
        },
    },
};
